import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import rootStore from 'store';
import './index.scss';
import App from './pages/App';
import './i18n'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={rootStore}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);